module.exports = __webpack_public_path__ + "img/disableshareicon.bf56fb8c.svg";